import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpService } from 'src/app/services/http.service';
import { Site } from '../../bo/site';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';
import { UtilisateurService } from '../../services/utilisateur.service';

@Component({
  selector: 'app-site-kpi',
  templateUrl: './site-kpi.component.html',
  styleUrls: ['./site-kpi.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteKpiComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  
  site = signal<Site>(null);
  erreurRecuperation = signal(false);
  configurationKPI1 = signal<{ id: number, nom: string }[]>([]);
  configurationKPI2 = signal<{ id: number, nom: string }[]>([]);
  configurationKPI3 = signal<{ id: number, nom: string }[]>([]);
  configurationKPI4 = signal<{ id: number, nom: string }[]>([]);
  selectedKPI1 = signal<number>(null);
  selectedKPI2 = signal<number>(null);
  selectedKPI3 = signal<number>(null);
  selectedKPI4 = signal<number>(null);
  configurationKPI = signal<number[]>([]);
  listeKPIActifs = signal<string[]>([]);
  startLoader: any;

  constructor(private readonly utilService: UtilisateurService, private readonly http: HttpService, private readonly fonctions: FonctionsService,
    private readonly traductionService: TraductionService) {
    utilService.currentSite$.pipe(takeUntilDestroyed()).subscribe(site => this.onChangeSite(site));
  }

  ngOnInit(): void {
    this.onChangeSite(this.utilService.currentSite());
  }

  onChangeSite(site: Site) {
    this.startLoader = setTimeout(() => {
      this.fonctions.loading_screen(true);
    }, 300);
    this.site.set(site);
    this.selectedKPI1.set(null);
    this.selectedKPI2.set(null);
    this.selectedKPI3.set(null);
    this.selectedKPI4.set(null);
    let configSite = this.http.get<string[]>('Sites/' + this.utilService.currentSite().siteId + '/ActiveAnalysisEntry');
    configSite.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(resultat => {
      this.listeKPIActifs.set(resultat);
      this.configKPI();
    }, () => {
      this.erreurRecuperation.set(true);
      this.fonctions.loading_screen(false);
      clearTimeout(this.startLoader);
    });
  }

  configKPI() {
    const listeActifs = this.listeKPIActifs();
    var nomsAvantTraduction = [];
    for (let i = 0; i < listeActifs.length; i++) {
      nomsAvantTraduction.push(listeActifs[i]["nom"]);
    }
    if (nomsAvantTraduction.length > 0) {
      this.traductionService.translate.get(nomsAvantTraduction)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(resultat => {
          const newConfig1: { id: number, nom: string }[] = [];
          for (let i = 0; i < listeActifs.length; i++) {
            newConfig1[i] = {
              id: listeActifs[i]["referentielDonneeAnalyseId"],
              nom: resultat[listeActifs[i]["nom"]],
            };
          }

          newConfig1.sort((a, b) => a.nom.localeCompare(b.nom));
          this.configurationKPI1.set(newConfig1);
          this.configurationKPI2.set(newConfig1);
          this.configurationKPI3.set(newConfig1);
          this.configurationKPI4.set(newConfig1);
          
          const currentSite = this.site();
          if (currentSite.configurationKPI != null && currentSite.configurationKPI.length >0) {
            var config = JSON.parse(currentSite.configurationKPI);
            if (config[0] != null) this.selectedKPI1.set(newConfig1.find(element => element.id === config[0])?.id);
            if (config[1] != null) this.selectedKPI2.set(newConfig1.find(element => element.id === config[1])?.id);
            if (config[2] != null) this.selectedKPI3.set(newConfig1.find(element => element.id === config[2])?.id);
            if (config[3] != null) this.selectedKPI4.set(newConfig1.find(element => element.id === config[3])?.id);
          }
          this.onChangeConfiguration();
          this.erreurRecuperation.set(false);
          this.fonctions.loading_screen(false);
          clearTimeout(this.startLoader);
        });
    } else {
      clearTimeout(this.startLoader);
    }
  }

  onSubmit(): void {
    const currentSite = this.site();
    currentSite.configurationKPI = JSON.stringify(this.configurationKPI());
    this.http.put<Site, Site>('Sites', currentSite)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(resultat => {
        this.fonctions.launch_toast(true);
        this.utilService.setCurrentSite(resultat);
      }, _ => this.fonctions.launch_toast(false));
  }

  onChangeConfiguration(): void {
    const kpi1 = this.selectedKPI1();
    const kpi2 = this.selectedKPI2();
    const kpi3 = this.selectedKPI3();
    const kpi4 = this.selectedKPI4();
    const config1 = this.configurationKPI1();
    
    this.configurationKPI2.set(config1.filter(o => o.id !== kpi1));
    this.configurationKPI3.set(config1.filter(o => (o.id !== kpi1 && o.id !== kpi2) || o.id === null));
    this.configurationKPI4.set(config1.filter(o => (o.id !== kpi1 && o.id !== kpi2 && o.id !== kpi3) || o.id === null));

    if (kpi1 === kpi2) {
      this.selectedKPI2.set(null);
      this.selectedKPI3.set(null);
      this.selectedKPI4.set(null);
    } if (kpi1 === kpi3) {
      this.selectedKPI3.set(null);
      this.selectedKPI4.set(null);
    } if (kpi1 === kpi4) {
      this.selectedKPI4.set(null);
    } if (kpi1 === null) {
      this.selectedKPI2.set(null);
      this.selectedKPI3.set(null);
      this.selectedKPI4.set(null);
    } if (kpi2 === kpi3) {
      this.selectedKPI3.set(null);
      this.selectedKPI4.set(null);
    } if (kpi2 === kpi4) {
      this.selectedKPI4.set(null);
    } if (kpi2 === null) {
      this.selectedKPI3.set(null);
      this.selectedKPI4.set(null);
    } if (kpi3 === kpi4) {
      this.selectedKPI4.set(null);
    } if (kpi3 === null) {
      this.selectedKPI4.set(null);
    }

    this.configurationKPI.set([
      this.selectedKPI1(),
      this.selectedKPI2(),
      this.selectedKPI3(),
      this.selectedKPI4()
    ]);
  }

}

